export default __webpack_public_path__ + "static/ai-marketing-1--mobile-c43bc1cf8db4aa69b083a7896b28c3f6.webp";